export default __webpack_public_path__ + "static/media/icon_attractions.ad11ca2b.svg";